import { Stack, TextField} from "@mui/material"

export const FilterCertification = ({ setFilterArray, copyArray }) => {

    const handleSubmit = (e) => {
        e.preventDefault();
        const filter = e.target.value?.toUpperCase();

        const newFilterArray = copyArray?.filter((row) => row.name.toUpperCase().includes(filter) || row.firstDate?.toString().includes(filter) || row.addressWork.toUpperCase().includes(filter) );

        setFilterArray(newFilterArray)
    }

    return (
        <Stack component='form' flexDirection='row' justifyContent='space-between' width='100%' mb='1rem' >
            <TextField
                label="Filtrar por cliente, fecha de inicio u obra"
                defaultValue=""
                size="small"
                name="filter"
                sx={{width:'100%'}}
                onChange={handleSubmit}
            />

        </Stack>
    )
}